export async function createPersonalInfo(personalInfoRepository, personalInfo) {
  return personalInfoRepository.save(personalInfo)
}